import { SP_NAMES } from "api/constants";
import { spApiInstance } from "api/instance";
import { IReq } from "api/types";
import { useState } from "react";

interface options {
  body?: IReq;
}

export const useItemLoader = <T>(spName: SP_NAMES, options?: options) => {
  const [item, setItem] = useState<T>();
  const [isLoading, setIsLoading] = useState(false);

  const loadData = async () => {
    try {
      setIsLoading(true);
      const result = await spApiInstance<T[]>(spName, options?.body);
      if (result && result.length) {
        setItem(result[0]);
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const fetch = () => {
    loadData();
  };

  const clear = () => {
    setItem(undefined);
  };

  return {
    isLoading,
    result: item,
    fetch,
    clear,
  };
};
